// extracted by mini-css-extract-plugin
module.exports = {"actions":"summary_actions__1A0Vm","submit":"summary_submit__1PW4h","exit":"summary_exit__3xNMn"};